import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import { ElMessage } from 'element-plus';

export interface ApiResponse<T = any> {
  code: number;
  message: string;
  data: T;
  success?: boolean;
  timestamp: string;
}

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem('beimi_c_auth_token');
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {}
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse<ApiResponse>) => {
    const res = response.data;
    if (res.code === 200 || res.success) {
      return res.data !== undefined ? res.data : res;
    }
    ElMessage.error(res.message || '系统繁忙，请稍后再试');
    return Promise.reject(new Error(res.message || 'Error'));
  },
  (error) => {
    const msg = error.response?.data?.message || error.message || '网络连接异常';
    ElMessage.error(msg);
    return Promise.reject(error);
  }
);

export default apiClient;
